// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7b14c90b","787":"7765f2c8"}[chunkId] + ".chunk.js";
};